import React, { useEffect, useState } from "react";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import Button from "../../Component/Common/Button";
import Pagination from "../../Component/Common/Pagination";
import Table from "../../Component/Common/Table";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getCommentsApi,
  deleteVideoComments,
} from "../../store/video/video.action";
import { warning } from "../../util/Alert";
import { covertURl } from "../../util/AwsFunction";
import dayjs from "dayjs";
import DataActions from "../../Component/Common/DataActions";

function VideoComments(props) {
  const { startDate, endDate } = props;
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [actionPagination, setActionPagination] = useState("");
  const [selectCheckData, setSelectCheckData] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [data, setData] = useState([]);

  const [showURLs, setShowURLs] = useState([]);
  const { commentData, totalVideoComment } = useSelector(
    (state) => state.video,
  );

  const [searchText, setSearchText] = useState("");
  const [debounceSearchText, setDebounceSearchText] = useState("");

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setPage(1);
    setSize(value);
  };
  const handleSelectCheckData = (e, row) => {
    const checked = e.target.checked;
    if (checked) {
      setSelectCheckData((prevSelectedRows) => [...prevSelectedRows, row]);
    } else {
      setSelectCheckData((prevSelectedRows) =>
        prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id),
      );
    }
  };
  const handleSelectAll = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      setSelectCheckData([...data]);
    } else {
      setSelectCheckData([]);
    }
  };

  const paginationSubmitButton = () => {
    const selectCheckDataGetId = selectCheckData?.map((item) => item?._id);
    if (actionPagination === "delete") {
      const data = warning();
      data
        .then((res) => {
          if (res) {
            const yes = res.isConfirmed;
            if (yes) {
              props.deleteVideoComments(selectCheckDataGetId);
            }
          }
        })
        .catch((err) => console.log(err));
    }

    setActionPagination("");
    setSelectCheckData([]);
    setSelectAllChecked(false);
  };

  const handleDeleteVideo = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            props.deleteVideoComments(id);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchData();
  }, [data]);

  const fetchData = async () => {
    if (!data || data.length === 0) {
      // Handle case when data is undefined or empty
      return;
    }

    const urls = await Promise.all(
      data.map(async (item) => {
        const fileNameWithExtension = item?.userImage?.split("/").pop();
        const { imageURL } = await covertURl(
          "userImage/" + fileNameWithExtension,
        );

        return imageURL;
      }),
    );
    setShowURLs(urls);
  };

  const commentMapData = [
    {
      Header: (
        <input
          type="checkbox"
          checked={selectAllChecked}
          onChange={handleSelectAll}
        />
      ),
      width: "20px",
      Cell: ({ row }) => (
        <input
          type="checkbox"
          checked={selectCheckData.some(
            (selectedRow) => selectedRow?._id === row?._id,
          )}
          onChange={(e) => handleSelectCheckData(e, row)}
        />
      ),
    },
    {
      Header: "NO",
      body: "no",
      Cell: ({ index }) => (
        <span className="  text-nowrap">
          {(page - 1) * size + parseInt(index) + 1}
        </span>
      ),
    },
    {
      Header: "VIDEO ID",
      body: "uniqueId",
      Cell: ({ row }) => <span className="">{row?.uniqueVideoId}</span>,
    },
    {
      Header: "TITLE",
      body: "title",
      Cell: ({ row }) => (
        <span className=" text-nowrap text-capitalize">{row?.videoTitle}</span>
      ),
    },
    {
      Header: "TEXT",
      body: "commentText",
      Cell: ({ row }) => <span className="">{row?.commentText}</span>,
    },
    {
      Header: "CREATED AT",
      body: "createdAt",
      Cell: ({ row }) => (
        <span className=" text-nowrap text-capitalize">
          {dayjs(row?.createdAt).format("MMMM-DD-YYYY")}
        </span>
      ),
    },
    {
      Header: "ACTION",
      body: "action",
      Cell: ({ row }) => (
        <div className="action-button">
          <Button
            className="icon-btn"
            startIcon={<TrashIcon />}
            onClick={() => handleDeleteVideo(row)}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    setData(commentData);
  }, [commentData]);

  useEffect(() => {
    dispatch(
      getCommentsApi({
        page,
        limit: size,
        startDate,
        endDate,
        videoType: 1,
        searchText: debounceSearchText,
      }),
    );
  }, [dispatch, startDate, endDate, page, size, debounceSearchText]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
      setDebounceSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  return (
    <div>
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className="row align-items-start mb-3">
            <h5
              style={{
                fontWeight: "500",
                fontSize: "20px",
                marginBottom: "4px",
                marginTop: "5px",
              }}
            >
              Manage Video Comments
            </h5>
          </div>

          <DataActions
            searchInputProps={{
              placeholder: "Search for ID, Title, Comment",
              value: searchText,
              onValueChange: (value) => setSearchText(value),
            }}
            showActionOptions={true}
            dropdownProps={{
              value: actionPagination,
              options: [
                {
                  label: "Delete",
                  value: "delete",
                },
              ],
              onChange: (value) => setActionPagination(value),
            }}
            actionButtonProps={{
              disabled: !actionPagination && !selectCheckData.length,
              onClick: paginationSubmitButton,
            }}
          />
        </div>

        <Table
          data={data}
          mapData={commentMapData}
          noDataMessage="No Comments Found!"
        />

        <div className="mt-3">
          <Pagination
            totalItem={totalVideoComment}
            activePage={page}
            pageSize={size}
            onActivePageChange={handlePageChange}
            onPageSizeChange={handleRowsPerPage}
          />
        </div>
      </div>
    </div>
  );
}
export default connect(null, {
  getCommentsApi,
  deleteVideoComments,
})(VideoComments);
